import {
	UPDATE_CONVERSATION_TITLE,
	UPDATE_CONVERSATION_TITLE_SUCCESS,
	UPDATE_CONVERSATION_TITLE_FAIL,
	UPDATE_CONVERSATION_TITLE_RESET,
} from '../actions/updateConversationTitleAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const updateConversationTitleReducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_CONVERSATION_TITLE:
			return {
				...state,
				apiState: 'loading',
			};
		case UPDATE_CONVERSATION_TITLE_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message || 'success',
			};
		case UPDATE_CONVERSATION_TITLE_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors || null,
				message: action.response.message || 'error',
			};
		case UPDATE_CONVERSATION_TITLE_RESET:
			return initialState;
		default:
			return state;
	}
};

export default updateConversationTitleReducer;
